import { FONT_FORMAT_LIST, SYSTEM_FONT_KEYS, SYSTEM_FONT_VALUES } from 'ContentUtils/constants/Fonts';

// Reverse of FONT_FORMAT_LIST: CSS stack ("'andale mono', times") -> display
// name ("Andale Mono"). A stored font value is the CSS stack, so this recovers
// the human-readable name for a label.
const SYSTEM_FONT_NAME_BY_VALUE = Object.fromEntries(Object.entries(FONT_FORMAT_LIST).map(([name, value]) => [value, name]));

// A HubSpot web-safe/system font matches a FONT_FORMAT_LIST key (display name)
// or value (CSS stack). System fonts are already installed and their value is a
// complete, valid font-family — so they need no loading.
export const isSystemFont = font => SYSTEM_FONT_KEYS.includes(font) || SYSTEM_FONT_VALUES.includes(font);

// The CSS stack for a system font, whether `font` is the display-name key or
// the stack value.
export const getSystemFontStack = font => {
  var _font;
  return (_font = FONT_FORMAT_LIST[font]) !== null && _font !== void 0 ? _font : font;
};

// The display name for a system font, whether `font` is the key or the stack.
export const getSystemFontName = font => {
  var _SYSTEM_FONT_NAME_BY_;
  return font in FONT_FORMAT_LIST ? font : (_SYSTEM_FONT_NAME_BY_ = SYSTEM_FONT_NAME_BY_VALUE[font]) !== null && _SYSTEM_FONT_NAME_BY_ !== void 0 ? _SYSTEM_FONT_NAME_BY_ : font;
};